import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAoCsZKNCCwNevFZIigAZ_qd00I4slw6QA",
    authDomain: "obcm-website.firebaseapp.com",
    projectId: "obcm-website",
    storageBucket: "obcm-website.firebasestorage.app",
    messagingSenderId: "70687982656",
    appId: "1:70687982656:web:bcf759e06d1427ec608ba5",
    measurementId: "G-7DLPH5QC92"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export {
    app
}